import axios from "axios";
import { baseURL } from "../../utils/URL";
import { toast } from "react-toastify";

const onGetOrgContacts = async (orgid: any, config: any) => {
  try {
    const response = await axios.get(
      `${baseURL}/crm/contact/organization/${orgid}`,
      config
    );
    return response.data;
  } catch (error: any) {
    console.log(error?.response);
    if (error?.response?.data?.message === undefined) {
      throw error.message;
    } else {
      throw error?.response?.data?.message;
    }
  }
};

const onAddContact = async (postData: any, config: any) => {
  try {
    const response = await axios.post(
      `${baseURL}/crm/contact`,
      postData,
      config
    );
    return response.data;
  } catch (error: any) {
    throw error?.response?.data.message;
  }
};
const onUpdateContact = async (id: any, postData: any, config: any) => {
  try {
    const response = await axios.patch(
      `${baseURL}/crm/contact/${id}`,
      postData,
      config
    );
    return response.data;
  } catch (error: any) {
    throw error?.response?.data.message;
  }
};
const onDeleteContact = async (id: any, config: any) => {
  try {
    const response = await axios.delete(`${baseURL}/crm/contact/${id}`, config);
    return response.data;
  } catch (error: any) {
    throw error?.response?.data.message;
  }
};
export { onGetOrgContacts, onDeleteContact, onUpdateContact, onAddContact };
